import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CustomHeaderComponent } from '../../component/custom-header/custom-header.component';
import { ActivatedRoute } from "@angular/router";
import { CommonService } from '../../shared/common';
import { messages } from 'src/app/shared/constants';
import { OrganizationService } from '../../services/organization.service';
import { AddorganizationmodalPage } from '../../modals/addorganizationmodal/addorganizationmodal.page';
import { UserService } from '../../services/user.service';
import { GlobalsService } from '../../shared/globals';
@Component({
  selector: 'app-organization',
  templateUrl: './organization.page.html',
  styleUrls: ['./organization.page.scss'],
})
export class OrganizationPage implements OnInit {

  public title = "";
  public organizationData = [];
  dataReturned: any;
  usersList = [];
  constructor(private customHeader: CustomHeaderComponent,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private OrganizationService: OrganizationService,
    public modalController: ModalController,
    private userService: UserService,
    private globals: GlobalsService
  ) {

  }
  ngOnInit() {
    this.commonService.assignGlobals();
    this.route.queryParams.subscribe(params => {
      this.title = params["Title"];
    });
    this.getOrganizationsData();
  }
  onEditOrganizationclick(orgData) {

    this.presentModal(orgData, false);
  }
  onAddOrganizationClick() {
    this.presentModal(0, true);
  }
  onDeleteOrganizationclick(orgData) {
    this.commonService.showAlert(messages.MESSAGETITLE, messages.DELETECONFIRM, [
      {
        text: 'Yes',
        handler: () => {
          this.deleteOrganizationsData(orgData.OrganizationID);
        }
      },
      {
        text: 'No',
        role: 'cancel'
      }
    ]);

  }

  async presentModal(orgData, isForNewOrg) {
    var tempOrgID = 0;
    var tempOrgName = "";
    var tempOrgStatus = true;
    if (!isForNewOrg) {
      tempOrgID = orgData.OrganizationID;
      tempOrgName = orgData.OrganizationName;
      tempOrgStatus = orgData.IsActive;
    }
    const modal = await this.modalController.create({
      component: AddorganizationmodalPage,
      componentProps: {
        'OrganizationID': tempOrgID,
        'OrganizationName': tempOrgName,
        'OrganizationStatus': tempOrgStatus,
        'usersList': this.usersList,
        'usersCount':orgData.UsersCount
      }
    });
    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        this.dataReturned = dataReturned.data.isCanceldismissed;
        if (!this.dataReturned) {
          this.getOrganizationsData();
        }
      }
    });

    return await modal.present();

  }
  getAllUsers() {
    if (navigator.onLine) {
      var self = this;
      this.usersList = [];

      this.userService
        .getAllUsers()
        .then((data: any) => {
          if (data.length > 0) {
            this.organizationData.forEach(orgElement => {
              data.forEach(function (element, index, object) {
                if (element.UserID == self.globals.userInfo.LoggedInUserID) {
                  //object.splice(index, 1);
                }
                if (orgElement.OrganizationID == element.OrganizationID) {
                  if (orgElement.UsersCount == undefined || orgElement.UsersCount == null || orgElement.UsersCount == '') {
                    orgElement.UsersCount = 0;
                  }
                  orgElement.UsersCount = orgElement.UsersCount + 1
                }
              });
              // data.forEach(element => {
              //   if(orgElement.OrganizationID == element.OrganizationID){
              //     if(orgElement.UsersCount == undefined || orgElement.UsersCount == null || orgElement.UsersCount == ''){
              //       orgElement.UsersCount = 0;
              //     }
              //     orgElement.UsersCount = orgElement.UsersCount + 1
              //   }
              // });
            });

            this.usersList = data;
          }
        })
        .catch((e) => {
        });
    } else {
      this.commonService.showAlert(messages.ALERTTITLINFORMATION, messages.PLEASECONNECTTONETWORK, ['OK']);
    }
  }
  async getOrganizationsData() {
    if (navigator.onLine) {
      this.organizationData = [];
      const loader = await this.commonService.showLoading(messages.GETORGANIZATIONDATA);
      this.OrganizationService
        .getOrganizationData()
        .then((data: any) => {
          loader.dismiss();
          if (data.length > 0) {
            data.forEach(element => {
              if (element.IsActive) {
                element.Status = 'Active';
              } else {
                element.Status = 'InActive';
              }
            });
            this.organizationData = data;
            this.getAllUsers();
          }
        })
        .catch((e) => {
          loader.dismiss();
        });
    } else {
      this.commonService.showAlert(messages.ALERTTITLINFORMATION, messages.PLEASECONNECTTONETWORK, ['OK']);
    }

  }
  async deleteOrganizationsData(organizationID) {
    if (navigator.onLine) {
      const loader = await this.commonService.showLoading(messages.DELETEORGDATA);
      this.OrganizationService
        .deleteOrganizationsData(organizationID)
        .then((data: any) => {
          loader.dismiss();
          if (data.Message == 'SUCCESS') {
            this.organizationData.forEach(function (item, index, object) {
              if (item.OrganizationID === organizationID) {
                object.splice(index, 1);
              }
            });

          }
        })
        .catch((e) => {

          loader.dismiss();
        });
    } else {
      this.commonService.showAlert(messages.ALERTTITLINFORMATION, messages.PLEASECONNECTTONETWORK, ['OK']);
    }

  }

}
